import React from "react";

export const useMonthOptions = () => {
    const months = React.useMemo(() => [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ], []);

    return months;
};

export const useYearOptions = () => {
    const years = React.useMemo(() => {
        const startYear = 2025;
        const endYear = 2030;
        const yearOptions = [];
        for (let year = startYear; year <= endYear; year++) {
            yearOptions.push({ value: year, label: year.toString() });
        }
        return yearOptions;
    }, []);

    return years;
};
